import { defineComponent as _defineComponent } from 'vue'
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import Notes from "@/components/contacts/Notes.vue";
  import ShareLotsModal from "@/components/ui/modals/ShareLotsModal.vue";
  import { computed, ref } from "vue";
  import store from "@/store";
  import { onMounted } from "vue-demi";
  import router from "@/router";
  import { getLeadStatusClass } from "@/helpers/status";
  import EnquiriesREA from "@/components/contacts/EnquiriesREA.vue";
  import { POSITION, useToast } from "vue-toastification";
  import { LeadStatus } from "@/enums/LeadStatus";
  import { SubscriptionInterface } from "@/types/SubscriptionInterface";
  import { formatPrice } from "@/helpers/transformation/price";
  import SwitchComponent from "@/components/ui/SwitchComponent.vue";
  import Enquiries from "@/components/contacts/Enquiries.vue";
  import LeadSourceEnum from "@/enums/LeadSourceEnum";
  import { LeadInterface } from "@/types/LeadInterface";
  import { capitalizeString } from "@/helpers/transformation/string";
  import { isCollaborator } from "@/helpers/estate/isCollaborator";
  import { EstateInterface } from "@/types/EstateInterface";
  import { useRequest } from "@/features/useRequest";
  import { EstateActions } from "@/store/modules/estate";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LeadDetails',
  setup(__props, { expose: __expose }) {
  __expose();

  const toast = useToast();
  const tabs = [{ label: "ENQUIRIES" }, { label: "NOTES" }];
  const estate = ref<EstateInterface | null>(null);
  const loading = ref(false);
  const userInfo = ref<LeadInterface | null>(null);
  const showShareModal = ref(false);
  const inWaitList = ref(false);
  const lotPrferences = ref<SubscriptionInterface>({} as SubscriptionInterface);
  const currentTab = ref(tabs[0]);

  const leadId = computed(() => router.currentRoute.value.params.id);
  const estateId = computed(() => store.state.user.selectedEstateId);
  const showPostcodeOrState = computed(() => {
    return userInfo.value?.postcode || userInfo.value?.state;
  });
  const crumbs = computed(() => {
    return [
      { label: "Leads", path: "/leads" },
      {
        label: `${userInfo.value?.firstName || ""} ${
          userInfo.value?.lastName || ""
        }`,
      },
    ];
  });
  const getEstate = async () => {
    const { handleRequestWithLoading } = useRequest(
      undefined,
      undefined,
      POSITION.TOP_LEFT
    );
    const res = await handleRequestWithLoading<EstateInterface, string>(
      EstateActions.GET_ESTATE,
      estateId.value,
      loading
    );

    estate.value = res?.data;
  };

  const isEstateCollaborator = computed(() => {
    if (!estate.value) return false;

    return isCollaborator(estate.value);
  });

  onMounted(() => {
    getUser();
    getEstate();
  });

  const getUser = () => {
    loading.value = true;
    store
      .dispatch("contact/getLead", leadId.value)
      .then((res) => {
        userInfo.value = res.data;

        if (!userInfo.value?.watched) {
          setWatchedLead();
        }

        return getSubscription();
      })
      .finally(() => {
        loading.value = false;
      });
  };

  const getSubscription = () => {
    return store
      .dispatch("subscription/getSubscription", {
        leadId: leadId.value,
        estateId: estateId.value,
      })
      .then((res) => {
        lotPrferences.value = res.data[0];
        inWaitList.value = !!lotPrferences.value?._id;
        return res.data;
      });
  };

  const setWatchedLead = () => {
    store.dispatch("contact/watchedLead", {
      estateId: estateId.value,
      leadIds: [leadId.value],
    });
  };

  const disableInvite = ref(false);

  function inviteToWaitlist() {
    disableInvite.value = true;
    store
      .dispatch("subscription/inviteLeadToWaitlist", {
        estateId: estateId.value,
        leadIds: [leadId.value],
      })
      .then(() => {
        toast.success("Email was sent successfully");
      })
      .catch(() => {
        toast.error("Something went wrong");
      })
      .finally(() => {
        disableInvite.value = false;
      });
  }
  function setLeadStatus(status: LeadStatus) {
    store
      .dispatch("contact/updateLead", { id: leadId.value, data: { status } })
      .then(() => getUser());
  }
  const removeFromWaitlist = () => {
    loading.value = true;
    store
      .dispatch("subscription/deleteSubscription", lotPrferences.value?._id)
      .then(() => {
        toast.success("The lead was successfully removed from waitlist");
        return getSubscription();
      })
      .catch(() => {
        toast.error("Something went wrong");
      })
      .finally(() => {
        loading.value = false;
      });
  };

const __returned__ = { toast, tabs, estate, loading, userInfo, showShareModal, inWaitList, lotPrferences, currentTab, leadId, estateId, showPostcodeOrState, crumbs, getEstate, isEstateCollaborator, getUser, getSubscription, setWatchedLead, disableInvite, inviteToWaitlist, setLeadStatus, removeFromWaitlist, Breadcrumbs, DropDown, Notes, ShareLotsModal, computed, ref, get store() { return store }, get onMounted() { return onMounted }, get router() { return router }, get getLeadStatusClass() { return getLeadStatusClass }, EnquiriesREA, get POSITION() { return POSITION }, get useToast() { return useToast }, get LeadStatus() { return LeadStatus }, get SubscriptionInterface() { return SubscriptionInterface }, get formatPrice() { return formatPrice }, SwitchComponent, Enquiries, get LeadSourceEnum() { return LeadSourceEnum }, get LeadInterface() { return LeadInterface }, get capitalizeString() { return capitalizeString }, get isCollaborator() { return isCollaborator }, get EstateInterface() { return EstateInterface }, get useRequest() { return useRequest }, get EstateActions() { return EstateActions } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})